// Angular
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';

// RxJS
import 'rxjs';

//jQuery
import 'jquery/dist/jquery';

//dx css
//import 'devextreme/dist/css/dx.common.css';
//import 'devextreme/dist/css/generic.light.custom.css';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./vendor.ts